const Q2P1 = [
  {
    text: "Reliable information on the merchant / partner, beneficial owners1, directors are publicly or easily available and matches the customer application business profile. ",
    type: "risk"
  },
  {
    text: "Credible and stable financial information on the merchant / partner is available from the bank letters / statements furnished by the merchant / partner during application.",
    type: "risk"
  },
  {
    text: "Merchant / partner or beneficial owner or directors matches with individuals or entities listed under MAS-designated sanctions lists, UN sanctions, terrorism financing or proliferation financing designations.",
    type: "risk"
  },
  {
    text: "Merchant / partner or beneficial owners1 or connected party has adverse news (e.g., Disputes, bankruptcy, offences, etc.) including checks via adverse media screening tools where available.",
    type: "risk"
  },
  {
    text: "Merchant / partner is involved in High-Risk Industry2 or business activities / products involving conflict of cross-border jurisdictions and infringements.",
    type: "risk"
  },
  {
    text: "Merchant/Partner is: a shell company, has complex shareholding structure (e.g., involving 3 layers or more of ownership structure, different jurisdictions, trusts); OR operates without an obvious commercial purpose.",
    type: "risk"
  },
  {
    text: "Merchant / Partner is a charitable or non-profit organization that is NOT registered in Singapore (charities.gov.sg/charity/index.do).",
    type: "risk"
  },
  {
    text: "Company is familiar with the merchant / Partner’s AML / CFT controls due to previous similar business dealings with the merchant or 3rd party referrals and recommendations.",
    type: "risk"
  },
  {
    text: "Merchant/Partner’s business operations and processing history are verifiable - Existing business vs new start-up",
    type: "risk"
  },{
    text:"Remarks",
    type:"remarks"
  }
]

const Q2P2 = [
  {
    text: "Merchant / partner business activities and operations are in a jurisdiction identified as high-risk for money laundering, terrorism financing, or proliferation financing3.",
    type: "risk"
  },
  {
    text: "Merchant / partner beneficial owners1 or natural persons are connected to jurisdictions with strategic AML/CFT/PF deficiencies3 in any of the above listed aspects.",
    type: "risk"
  },
  {
    text: "The merchant / partner is from a jurisdiction that lacks equivalent AML/CFT and Proliferation Financing measures that are able to mitigate the risks of being from a high risk jurisdictions3 country.",
    type: "risk"
  },{
    text:"Remarks",
    type:"remarks"
  }
]

const Q2P3 = [
  /*
  {
    text: "Merchant is involved in High-Risk Industry or business activities / products involving conflict of cross-border jurisdictions and infringements.",
    type: "risk"
  },
  */
  {
    text: "Merchant/ Partner product mix history and pattern of sale changes frequently.",
    type: "risk"
  },
  {
    text: "Product and services offered by merchant / partner are exposed to regulatory scrutiny or restrictions across cross-border jurisdictions.",
    type: "risk"
  },
  {
    text: "General and common trading products and services with small transaction values.",
    type: "risk"
  },
  {
    text: "Business transaction pattern and history is regular and reliable. (eg. Chargeback history within threshold limits set by credit card associations, refund history, payment processor history, etc)",
    type: "risk"
  },
  {
    text: "Merchant/ Partner has existing anti-fraud systems for their transaction monitoring.",
    type: "risk"
  },
  {
    text: "Merchant/ partner business portal and operation mode is transparent. Secure access is available to view products, transactions, and user account flows.",
    type: "risk"
  },{
    text:"Remarks",
    type:"remarks"
  }
]

const Q2P4 = [
  {
    text: "Merchant/ Partner relationship is established through non-face-to-face approach (eg. Online enquiry, telephone, postal modes)",
    type: "risk"
  },
  {
    text: "Merchant/ Partner relationship is established through referral or recommendation.",
    type: "risk"
  },{
    text:"Remarks",
    type:"remarks"
  }
]

export { 
  Q2P1, 
  Q2P2, 
  Q2P3, 
  Q2P4
}